import { Stack, Card, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import AutoHome from '../../../assets/icons/AutoHome';
import Button from '../../../components/styledComponents/Button';
import colors from '../../../constants/colors';
import useAnalytics from '../../../hooks/useAnalytics';
import theme from '../../../styles/theme';

const AutoPayBulkEnrollCard = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'));
  const navigate = useNavigate();
  const { track } = useAnalytics();
  const handleBulkEnroll = () => {
    track('AutoPay Modified', {
      location: 'Feature Card',
      link: 'Set up AutoPay',
      setup_type: 'all policies',
      event_type: 'Link Accessed',
    });
    navigate('method', {
      state: { edit: false, bulk: true },
    });
  };

  return (
    <Card
      component={Stack}
      sx={{
        boxShadow: '0px 4px 8px rgba(25, 30, 43, 0.08)',
        p: { tablet: 5, mobile: 2 },
        borderRadius: 2,
        height: 'auto',
      }}
    >
      <Stack spacing={2} direction="row">
        {!isMobile && <AutoHome />}
        <Stack
          direction={{ mobile: 'column', tablet: 'row' }}
          justifyContent="space-between"
          width={1}
          spacing={{ mobile: 3, tablet: 0 }}
        >
          <Stack
            spacing={{ mobile: 1, tablet: 0.5 }}
            direction="column"
            justifyContent="center"
          >
            <Typography
              sx={{
                fontFamily: 'Cabin',
                fontKerning: 'normal',
                fontWeight: 700,
                fontSize: { mobile: 16, tablet: 18 },
                color: colors.csaaBlack,
                lineHeight: '25.2px',
              }}
            >
              Set up all policies eligible for AutoPay
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Cabin',
                fontKerning: 'normal',
                fontWeight: 400,
                fontSize: { mobile: 16, tablet: 18 },
                color: colors.csaaBlack,
                lineHeight: '25.2px',
              }}
            >
              Conveniently make payments on more than one policy.
            </Typography>
          </Stack>
          <Button
            data-testid="bulkEnrollAutoPayButton"
            variant="contained"
            sx={{
              whiteSpace: 'nowrap',
              height: { mobile: 36, tablet: 42 },
              alignSelf: 'center',
            }}
            onClick={handleBulkEnroll}
          >
            Set up AutoPay
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
};

export default AutoPayBulkEnrollCard;
